<template lang="pug">
div
  #content.snap-content
    .content-center(v-if="error")
      .icon-dialog.text-center.mt-5(style='color:#ffc902')
        i.fas.fa-tools
      .head-notice.text-center.text-white
        i.fas.fa-exclamation-triangle.mr-1
        span {{ error }}
      .w-100.mx-auto.px-2.text-center.text-white
        //- p.font-italic.mb-5 Dear valued customers, our system currently under maintenance.
        //- p Estimate maintenance time:
        //- p.font-weight-bold.mb-5
        //-   | From : Wednesday, 24 July, 2019 1:30:00 PM
        //-   br
        //-   | To : Wednesday, 24 July, 2019 3:30:00 PM
        //- p.mt-5.mb-1 Sorry for the inconvenience caused.
    .content-center(v-else)
      .loader

</template>

<script>
import config from "@/config";
import xhr from "@/library/_xhr-game.js";

export default {
  data() {
    return {
      url: "",
      error: ""
    };
  },
  created() {
    var q = this.$route.query;
    var suite = "1";
    if (q.suite) {
      suite = q.suite;
    }
    switch (suite) {
      case "0":
        this.launchGP("1");
        break;
      case "1":
        this.launchGP("1");
        break;
      case "2":
        this.launchGP("2");
        break;
      case "3":
        this.launchSA(true);
        break;
      case "4":
        // CT855
        this.launchCT(true);
        break;
      case "5":
        // vivo
        this.launchVivo(true);
        break;
      case "6":
        // Big Gaming
        break;
      case "7":
        // PrettyGaming
        this.launchPG(true);
        break;
      case "8":
        // Evolution
        this.launchEV(true);
        break;
      case "9":
        // Yeebet
        this.launchYB(true);
        break;
      case "10":
        //pragmatic casino
        this.launchLCPPG(true);
        break;
      case "11":
        //ai casino
        this.launchAiCasino(true);
        break;
    }
  },
  methods: {
    getCountry() {
      const url = "https://geo.wbet.workers.dev/";
      return new Promise((resolve, reject) => {
        this.$http.get(url).then(
          res => {
            resolve(res.bodyText);
          },
          err => {
            reject(err);
          }
        );
      });
    },
    launchGP(suite) {
      var args = {
        player_id: this.$store.getters.accountId,
        password: this.$store.getters.sessionToken,
        studio: suite,
        clienttype: "h5",
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language
      };

      xhr.launchGP(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchSA(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchSA(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchCT(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchCT(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchVivo(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchVivo(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchPG(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchPG(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchEV(mode) {
      var currency = this.$store.getters.currencyCode;

      this.getCountry().then(
        res => {
          var json = JSON.parse(res);
          if (json.country == "SG") {
            if (currency == "SGD") {
              this.launchEvoInternal(mode);
            } else {
              this.error = this.$t("error.forbiddenAccess");
            }
          } else {
            this.launchEvoInternal(mode);
          }
        },
        err => {
          this.error = err;
        }
      );
    },
    launchEvoInternal(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        currency: this.$store.getters.currencyCode,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchEV(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            } else {
              if (res.status == "liveCasinoDisabled") {
                this.error = this.$t("error." + res.status);
              } else {
                this.error = this.$t("error.game_maintenance");
              }
            }
          }
        },
        err => {
          this.loading = false;
          if (err.status == "liveCasinoDisabled") {
            this.error = this.$t("error." + err.status);
          } else {
            this.error = this.$t("error.game_maintenance");
          }
        }
      );
    },
    launchYB(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchYB(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchLCPPG(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchLCPPG(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    },
    launchAiCasino(mode) {
      var mobile = false;
      if (mode) {
        mobile = mode;
      }
      var args = {
        username: this.$store.getters.accountId,
        sessionid: this.$store.getters.sessionToken,
        lang: this.$store.getters.language,
        mobile: mobile.toString()
      };

      xhr.launchAiCasino(args).then(
        res => {
          this.loading = false;
          if (res) {
            if (res.success == true) {
              this.url = res.data;
              if (this.url.includes("http")) {
                setTimeout(() => {
                  window.location.replace(this.url);
                }, 100);
              } else {
                switch (res.status) {
                  case "lotteryDisabled":
                  case "currencyNotSupported":
                  case "liveCasinoDisabled":
                  case "EsportsDisabled":
                  case "MiniGameDisabled":
                    this.error = this.$t("error." + res.status);
                    break;
                  case "account_status_suspend":
                    this.error = this.$t("error.SUSPEND");
                    break;
                  default:
                    this.error = this.$t("error.game_maintenance");
                    break;
                }
              }
            } else {
              switch (res.status) {
                case "lotteryDisabled":
                case "currencyNotSupported":
                case "liveCasinoDisabled":
                case "EsportsDisabled":
                case "MiniGameDisabled":
                  this.error = this.$t("error." + res.status);
                  break;
                case "account_status_suspend":
                  this.error = this.$t("error.SUSPEND");
                  break;
                default:
                  this.error = this.$t("error.game_maintenance");
                  break;
              }
            }
          }
        },
        err => {
          this.loading = false;
          switch (err.status) {
            case "lotteryDisabled":
            case "currencyNotSupported":
            case "liveCasinoDisabled":
            case "EsportsDisabled":
            case "MiniGameDisabled":
              this.error = this.$t("error." + err.status);
              break;
            case "account_status_suspend":
              this.error = this.$t("error.SUSPEND");
              break;
            default:
              this.error = this.$t("error.game_maintenance");
              break;
          }
        }
      );
    }
  }
};
</script>